import { daysOfTheWeekS, generalHelpers, months } from '@monorepo/helpers';

class Helpers {
    BlobToBase64 = (blob: Blob): Promise<string> => {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onloadend = () => resolve((reader.result as string).split(',')[1]);
            reader.readAsDataURL(blob);
        });
    }
    GetDayOfWeekFromDateString = (date: string): string => {  // YYYY-mm-DD => 'weekday'
        const parts = date.split('-');
        const dateJs = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        const response = daysOfTheWeekS[dateJs.getDay()];
        return response;
    }
    GetCalendarWeekRange = (week: number, year: number) => {
        const jan1 = new Date(year, 0, 1);
        const day = jan1.getDay();
        const baseMonday = new Date(jan1);
        baseMonday.setDate(jan1.getDate() - ((day + 6) % 7));
        const start = new Date(baseMonday);
        start.setDate(start.getDate() + (week - 1) * 7);
        const end = new Date(start);
        end.setDate(start.getDate() + 6);
        return {
            maxDate: generalHelpers.FormatDate(end),
            maxDateStr: end.toLocaleDateString().split(year.toString())[0].slice(0, -1),
            minDate: generalHelpers.FormatDate(start),
            minDateStr: start.toLocaleDateString().split(year.toString())[0].slice(0, -1)
        };
    }
    GoToTop = (top = 0): void => {
        window.scrollTo({ top, behavior: 'smooth' });
    }
    NormalizeString = (value: string): string => {
        return `${value.toLowerCase()
            .replace(/\s+/g, '-')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/ñ/g, 'n')}`
        ;
    }
    TimeConverter = (UNIX_timestamp: number, withHour: boolean = true): string => {
        try {
            const a: Date = new Date(UNIX_timestamp);
            const year = a.getFullYear();
            const month = months[a.getMonth()];
            const date = a.getDate();
            const hour = a.getHours();
            const min = a.getMinutes() < 10 ? "0" + a.getMinutes() : a.getMinutes();
            let time: string;
            if (withHour) {
                time = date + " de " + month + " de " + year + " - " + hour + ":" + min + " hs.";
            } else {
                time = date + " de " + month + " de " + year;
            }
            return time;
        } catch (error) {
            console.log(error);
            return "Error en la fecha...";
        }
    }
}

export const helpers = new Helpers();
